import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { NOMINATION_STATUSES, NominationStatus } from 'types/efforts';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

type Props = {
    value: NominationStatus;
    onChange: (status: NominationStatus) => void;
    /** Names the nomination: one person can hold several on one form, list or tab. */
    label: string;
    disabled?: boolean;
    className?: string;
};

/** A nomination's status as the kit select at its small size, the way a table row holds one. */
export function NominationStatusSelect({ value, onChange, label, disabled, className }: Props) {
    return (
        <Select<NominationStatus>
            value={value}
            disabled={disabled}
            onValueChange={(status) => {
                if (status !== null) onChange(status);
            }}
        >
            {/* A width, not a min-width: a list cell's `td > * { min-width: 0 }` would undo the latter. */}
            <SelectTrigger size="sm" aria-label={label} className={cn('bg-paper w-[140px]', className)}>
                <SelectValue>
                    {(status: NominationStatus | null) => (status ? t(`rankings-referees.status.${status}`) : '')}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {NOMINATION_STATUSES.map((status) => (
                    <SelectItem key={status} value={status}>
                        {t(`rankings-referees.status.${status}`)}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
